import { render, staticRenderFns } from "./MyQuotes.vue?vue&type=template&id=97f29a40&scoped=true&"
import script from "./MyQuotes.vue?vue&type=script&lang=js&"
export * from "./MyQuotes.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotes.vue?vue&type=style&index=0&id=97f29a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f29a40",
  null
  
)

export default component.exports